import React from "react";
import ModalPopup from "../../Common/Modal/Modal";
import { Table } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import ReactPaginate from "react-js-pagination";
import { Formik, Field, ErrorMessage, Form } from "formik";
import { useState, useEffect } from "react";
import { IoIosAdd } from "react-icons/io";
import * as Yup from "yup";
import { MdDelete, MdEdit } from "react-icons/md";
import { ConfigProvider, DatePicker, Upload, Select } from "antd";
import dayjs from "dayjs";
import { useSelector, useDispatch } from "react-redux";
import { TbsPercentage } from "../../../Api/Settings/ProductIntegration/Integration";
import { TbsDealPercentage } from "../../../Api/Settings/ProductIntegration/Integration";
import { toast } from "react-toastify";
import DeleteList from "./Delete";
import { format } from "path-browserify";
import {
  TbsupdateData,
  TbsDealPercentageById,
} from "../../../Api/Settings/ProductIntegration/Integration";
import { Tooltip } from "antd";
import {
  TiArrowUnsorted,
  TiArrowSortedUp,
  TiArrowSortedDown,
} from "react-icons/ti";

const apiUrl = process.env.REACT_APP_API_URL;

export default function IntegrationTable() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [togglepage, setTogglePage] = useState(1);
  const [activePage, setActivePage] = useState(1);
  const { RangePicker } = DatePicker;

  const dispatch = useDispatch();
  const [updateData, setUpdateData] = useState();

  const [deleteId, setIdDelete] = useState();

  const [deletemodalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [dealId, setDealId] = useState();
  const [fetchData, setFetchData] = useState([]);
  console.log("fetchDatafetchData", fetchData?.from_date);

  const [editId, setId] = useState();
  const [sortOrderPercentageValue, setSortOrderPercentageValue] = useState(null);
  const [sortOrderDuration, setSortOrderDuration] = useState(null);
   const [sortOrderDate, setSortOrderDate] = useState(null);
const [sortedData, setSortedData] = useState([]);
 const crud=sessionStorage.getItem("crud_permission")
  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
  };
  useEffect(() => {
    TbsPercentage(dispatch);
  }, [dispatch]);

  const formatFrom = (dateStr) => {
    if (!dateStr) return "";

    // Assuming input is in DD/MM/YYYY format
    const [day, month, year] = dateStr.split("/").map(Number);
    const date = new Date(year, month - 1, day); // JS months are 0-indexed

    const dayFormatted = date.getDate().toString().padStart(2, "0");
    const monthShort = date.toLocaleString("en-US", { month: "short" });

    return `${year}/${monthShort}/${dayFormatted} `;
  };
  const formatTo = (dateStr) => {
    if (!dateStr) return "";

    // Assuming input is in DD/MM/YYYY format
    const [day, month, year] = dateStr.split("/").map(Number);
    const date = new Date(year, month - 1, day); // JS months are 0-indexed

    const dayFormatted = date.getDate().toString().padStart(2, "0");
    const monthShort = date.toLocaleString("en-US", { month: "short" });

    return `${year}/${monthShort}/${dayFormatted} `;
  };

  const tbsDeal = useSelector((state) => state.crm.tbs_deal);
  const formatDate = (dateStr) => {
    const [datePart, timePartRaw] = dateStr.split(",");
    const [day, month, year] = datePart.trim().split("/");

    const date = new Date(year, month - 1, day);
    const dayFormatted = date.getDate().toString().padStart(2, "0");
    const monthShort = date.toLocaleString("en-GB", { month: "short" });
    const timePart = timePartRaw.trim();
    const [time, ampm] = timePart.split(" ");
    let [hour, min, sec] = time.split(":");

    hour = parseInt(hour);
    hour = hour % 12;
    hour = hour ? hour : 12;
    hour=hour.toLocaleString("en-GB",{hour:"2digit"}).padStart(2,"0");
    const formattedDate = `${dayFormatted} ${monthShort} ${year}`;
    const formattedTime = `${hour}:${min}`;

    return `${formattedDate} (${formattedTime} ${ampm.toUpperCase()})`;
  };

  const formatDateFrom = (dateStr) => {
    if (!dateStr) return "";
    const [day, month, year] = dateStr.split("/");
    const date = new Date(year, month - 1, day);

    const dayFormatted = date.getDate().toString().padStart(2, "0");
    const monthShort = date.toLocaleString("en-GB", { month: "short" });
    const yearFormatted = date.toLocaleString("en-GB", { year: "2-digit" });

    return `${dayFormatted} ${monthShort} ,${yearFormatted}`;
  };

  const formatDateTo = (dateStr) => {
    if (!dateStr) return "";

    // const [datePart, timePart] = dateStr.split("T");
    const [day, month, year] = dateStr.split("/");
    const date = new Date(year, month - 1, day);

    const dayFormatted = date.getDate().toString().padStart(2, "0");
    const monthShort = date.toLocaleString("en-GB", { month: "short" });
    const yearFormatted = date.toLocaleString("en-GB", { year: "2-digit" });
    return `${dayFormatted} ${monthShort} ,${yearFormatted}`;
  };
     

  const itemsper = 5;
  console.log(itemsper, "itemperpage");

  const handlePageChange = (selectedPage) => {
    setActivePage(selectedPage);
    console.log("Selected page:", selectedPage);
  };

  const indexOfLastItem = activePage * itemsper;
  const indexOfFirstItem = indexOfLastItem - itemsper;

  const currentItems =
    sortedData.length > 0
      ? sortedData.slice(indexOfFirstItem, indexOfLastItem)
      : tbsDeal?.length > 0 &&
        tbsDeal?.slice(indexOfFirstItem, indexOfLastItem);
         

    const handlePercentageSort = () => {
  let sorted = [...tbsDeal];
  if (sortOrderPercentageValue === "ascend") {
    
    sorted.sort((a, b) => {
      if (
        typeof a?.percentage === "string" &&
        typeof b?.percentage === "string"
      ) {
        return b.percentage - a.percentage;
      }
      const valueA = String(a?.percentage || "");
      const valueB = String(b?.percentage || "");
      return valueB.localeCompare(valueA);   
    });
    setSortOrderPercentageValue("descend");
    setSortedData(sorted);
  } else if (sortOrderPercentageValue === "descend") {
    
    setSortOrderPercentageValue(null);
    setSortedData(tbsDeal); 
  } else {
    
    sorted.sort((a, b) => {
      if (
        typeof a?.percentage === "string" &&
        typeof b?.percentage === "string"
      ) {
        return a.percentage - b.percentage;
      }
      const valueA = String(a?.percentage || "");
      const valueB = String(b?.percentage || "");
      return valueA.localeCompare(valueB);
    });
    setSortOrderPercentageValue("ascend");
    setSortedData(sorted);
  }

  console.log(tbsDeal, "sort details");
};

const handleDurationSort = () => {
  let sorted = [...tbsDeal];
  const getDuration = (item) => {
  const start = dayjs(item.from_date, "D/M/YYYY");
  const end = dayjs(item.to_date, "D/M/YYYY");
  return end.diff(start, "day");   // duration in days
};


  if (sortOrderDuration === "ascend") {
    // DESCENDING: largest duration first
    sorted.sort((a, b) => getDuration(b) - getDuration(a));
    setSortOrderDuration("descend");
  } 
  else if (sortOrderDuration === "descend") {
    // RESET to default
    sorted = [...tbsDeal];
    setSortOrderDuration(null);
  } 
  else {
    // ASCENDING: smallest duration first
    sorted.sort((a, b) => getDuration(a) - getDuration(b));
    setSortOrderDuration("ascend");
  }

  setSortedData(sorted);
};


// const handleDateSort = () => {
//   let sorted = [...tbsDeal];

//   if (sortOrderDate === "ascend") {
//     sorted.sort((a, b) => parseDate(b.created_date) - parseDate(a.created_date));
//     setSortOrderDate("descend");
//   } else if (sortOrderDate === "descend") {
//     setSortOrderDate(null);
//     sorted = tbsDeal; 
//   } else {
//     sorted.sort((a, b) => parseDate(a.created_date) - parseDate(b.created_date));
//     setSortOrderDate("ascend");
//   }

//   setSortedData(sorted);
// };

const handleDateSort = () => {
  let sorted = [...tbsDeal];

  const parseDate = (d) => dayjs(d, "D/M/YYYY, h:mm:ss a").toDate();

  if (sortOrderDate === "ascend") {
    // Switch to DESC
    sorted.sort((a, b) => parseDate(b.created_date) - parseDate(a.created_date));
    setSortOrderDate("descend");
  } 
  
  else if (sortOrderDate === "descend") {
    // Reset list
    sorted = [...tbsDeal];
    setSortOrderDate(null);
  } 
  
  else {
    // ASC sort
    sorted.sort((a, b) => parseDate(a.created_date) - parseDate(b.created_date));
    setSortOrderDate("ascend");
  }

  setSortedData(sorted);
};



const parseDate = (value) => {
  return value && dayjs(value).isValid()
    ? dayjs(value).format("YYYY-MM-DD")
    : "";
};


// const handleDateSort = () => {
//   let sorted = [...tbsDeal];

//   if (sortOrderDate === "ascend") {
//     sorted.sort((a, b) => parseDate(b.created_date) - parseDate(a.created_date));
//     setSortOrderDate("descend");
//   } else if (sortOrderDate === "descend") {
//     setSortOrderDate(null);
//     sorted = tbsDeal; 
//   } else {
//     sorted.sort((a, b) => parseDate(a.created_date) - parseDate(b.created_date));
//     setSortOrderDate("ascend");
//   }

//   setSortedData(sorted);
// };


  const validationSchema = Yup.object().shape({
    from_date: Yup.date(),
      // .min(new Date(), 'Start Date cannot be in the past'),
      to_date: Yup.date(),
        // .min(Yup.ref("start_date"), "Expiry Date must be after Start Date"),
    
       
    percentage: Yup.number()
  .typeError("Percentage must be a number")
  .required("Percentage is required")
  .min(1, "Percentage must be at least 1")
  .max(100, "Cannot be more than 100"),
    value_symbol: Yup.string().oneOf(["%"]).required(),
  })
  .test(
      "both-required",
      "Start Date and End Date are required",
      function (value) {
        const { from_date, to_date } = value || {};
        if (!from_date && !to_date) {
          return this.createError({
            path: "from_date",
            message: "Start Date and End Date are required",
          });
        }
          return true;
  }
        );

  const fetchDeal = async () => {
    try {
      if (editId) {
        const data = await TbsDealPercentageById(editId);
        setFetchData((prevState) => ({
          ...prevState,
          percentage: data.percentage,
          from_date: data.from_date,
          to_date: data.to_date,
        }));

        console.log("DeeeeeeeeelDaaaata", data);

        return data;
      }
    } catch (error) {
      console.error("Error fetching theme background:", error);
    }
  };
  useEffect(() => {
    fetchDeal();
  }, [editId]);
  useEffect(() => {
    console.log("fetchData updated", fetchData);
  }, [fetchData]);

  const handleSubmit = async (values) => {
    console.log("Form values:", values);

    try {
      const response = await TbsupdateData(fetchData, editId, values, dispatch);
      console.log("API Response:", response);
    } catch (err) {
      console.error("Submission error:", err);
      toast.error("Something went wrong!");
    } finally {
      setUpdateData(null);
      setTogglePage(1);
    }
  };

  useEffect(() => {
      if (currentItems?.length === 0) {
        setActivePage(activePage - 1);
      }
    }, [currentItems, setActivePage, activePage]);


    
const disabledDate = (current) => {
  // Disable dates before today
  return current && current < new Date().setHours(0, 0, 0, 0);
};


  const columns = [
    {
      title: (
        <div
          className="text-[1.2vw] text-center font-bold"
          style={{ color: "white" }}
        >
          S.No
        </div>
      ),
      width: "8vw",
      render: (row, rowdta, index) => {
        const serialNumber = (activePage - 1) * itemsper + (index + 1);

        return (
          <div className="flex justify-center text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            {serialNumber}
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="flex items-center justify-center text-[1.2vw]">
          Percentage
          <button onClick={handlePercentageSort} className="">
                                {sortOrderPercentageValue === "ascend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                ) : sortOrderPercentageValue === "descend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Descending"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedDown />
                                  </Tooltip>
                                ) : sortOrderPercentageValue === null ? (
                                  <Tooltip
                                    placement="top"
                                    title="Unsorted"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowUnsorted />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                )}
                              </button>
        </h1>
      ),

      render: (row) => {
        return (
          <div className=" text-[1vw] flex items-center justify-center text-[#1F487C]">
            {row?.percentage ? `${Number(parseFloat(row.percentage))}%` : "-"}
          </div>
        );
      },
    },

    {
      title: (
        <h1 className="flex items-center justify-center text-[1.2vw]">
          Duration
          <button onClick={handleDurationSort} className="">
                                          {sortOrderDuration === "ascend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          ) : sortOrderDuration === "descend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Descending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedDown />
                                            </Tooltip>
                                          ) : sortOrderDuration === null ? (
                                            <Tooltip
                                              placement="top"
                                              title="Unsorted"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowUnsorted />
                                            </Tooltip>
                                          ) : (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          )}
                                        </button>
        </h1>
      ),

      render: (row) => {
        return (
          <div className="text-[1vw] flex items-center justify-center text-[#1F487C]">
            {formatDateFrom(row?.from_date)} - {formatDateTo(row?.to_date)}
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="flex items-center justify-center text-[1.2vw]">
          Created Date
          <button onClick={handleDateSort} className="">
                                          {sortOrderDate === "ascend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          ) : sortOrderDate === "descend" ? (
                                            <Tooltip
                                              placement="top"
                                              title="Descending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedDown />
                                            </Tooltip>
                                          ) : sortOrderDate === null ? (
                                            <Tooltip
                                              placement="top"
                                              title="Unsorted"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowUnsorted />
                                            </Tooltip>
                                          ) : (
                                            <Tooltip
                                              placement="top"
                                              title="Ascending"
                                              className="cursor-pointer"
                                              color="white"
                                              overlayInnerStyle={{
                                                color: "#1F487C",
                                              }}
                                            >
                                              <TiArrowSortedUp />
                                            </Tooltip>
                                          )}
                                        </button>
        </h1>
      ),

      render: (row) => {
        return (
          <div className="text-[1vw] flex items-center justify-center text-[#1F487C]">
            {row?.created_date ? formatDate(row?.created_date) : "-"}
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.2vw] font-semibold text-center  flex items-center justify-center">
          Action
        </h1>
      ),

      render: (row) => {
        console.log(row, "rowrowrowrow");
        return (
          <div className="flex gap-[0.7vw] items-center justify-center">
            <MdEdit
              size={"1.3vw"}
              color="#1F4B7F"
              className=" cursor-pointer"
              onClick={() => {
                setTogglePage(2);
                setDealId(row?.user_id);
                setId(row?.id);
                fetchDeal();
              }}
            />
            {/* <MdDelete
                    size={"1.3vw"}
                    color="#1F4B7F"
                    className=" cursor-pointer"
                    onClick={() => {
                      setDeleteModalIsOpen(true);
                      setUpdateData(row?.user_id);
                      setIdDelete(row?.id);
                    }}
                  /> */}
          </div>
        );
      },
    },
  ];
  return (
    <div className="p-[2vw]">
      {togglepage === 1 ? (
        <div className="flex justify-end mr-[0.1vw]">
          <button
            className={`bg-white text-[#1F487C] border-[0.1vw] border-b-[0.2vw] border-r-[0.2vw] border-[#1F487C] rounded-[0.5vw] py-[0.25vw] outline-none flex items-center  px-[1vw] gap-[0.25vw] ${crud?.includes("delete")||crud?.includes("view")||crud?.includes("update") ? "cursor-not-allowed":"cursor-pointer"}`}
            onClick={() => {
              setFetchData("");
              setTogglePage(2);
            }}
            disabled={crud?.includes("delete")||crud?.includes("view")||crud?.includes("update")}
          >
            <IoIosAdd size={"1.5vw"} />{" "}
            <span className="text-[1.2vw]">Add</span>
          </button>
        </div>
      ) : (
        ""
      )}

      {togglepage === 1 ? (
        <Table
          className="custom-table mt-[2vw]"
          columns={columns}
          dataSource={currentItems}
          pagination={false}
        />
      ) : (
        <Formik
          initialValues={{
            percentage: fetchData
              ? Number(parseFloat(fetchData?.percentage))
              : "",
        
from_date: parseDate(fetchData?.from_date),
  to_date: parseDate(fetchData?.to_date),

            user_id: fetchData ? fetchData.user_id : "",
            value_symbol: updateData?.value_symbol || "%",
          }}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={(values) => {
            handleSubmit(values);

            console.log("Form Submitted valuesvalues:", values);
          }}
        >
          {({ values, handleSubmit, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <div>
                <div className="grid grid-rows-1 justify-center items-center">
                  {/* Duration Field (Date Range Picker) */}
                  <div className="relative w-[22vw] reqman col-span-1 flex flex-col pb-[1.2vw]">
                    <label className="text-[#1F4B7F] text-[1.1vw] font-semibold">
                      Duration
                      <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                        *
                      </span>
                    </label>

                    <ConfigProvider
                      theme={{
                        token: {
                          fontSize: ".9vw",
                          colorPrimary: "#1F487C",
                        },
                        components: {
                          DatePicker: {
                            activeBorderColor: "#1F487C",
                            hoverBorderColor: "#1F487C",
                            activeShadow: "#1F487C",
                            cellWidth: 25,
                            cellHeight: 20,
                          },
                        },
                      }}
                    >
                      <RangePicker
                        allowClear={true}
                        autoFocus={false}
                        inputReadOnly={true}
                        disabledDate={disabledDate}
                        value={[
                          values.from_date ? dayjs(values.from_date) : null,
                          values.to_date ? dayjs(values.to_date) : null,
                        ]}
                        onChange={(dates) => {
                          const [from_date, to_date] = dates || [];
                          setFieldValue(
                            "from_date",
                            from_date ? from_date.format("YYYY-MM-DD") : ""
                          );
                          setFieldValue(
                            "to_date",
                            to_date ? to_date.format("YYYY-MM-DD") : ""
                          );
                        }}
                        // disabledDate={(current) => {
                        //   const maxDate = dayjs().add(3, 'months');
                        //   return current < dayjs().startOf('day') || current > maxDate;
                        // }}
                        className="ads-date border-r-[0.25vw] mt-[0.5vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] w-full rounded-[0.5vw] outline-none px-[1vw] placeholder:text-[1vw]"
                      />
                    </ConfigProvider>

                    <ErrorMessage
                      name="from_date"
                      component="div"
                      className="text-red-500 text-[0.8vw] absolute mt-[5.2vw]"
                    />
                    <ErrorMessage
                      name="to_date"
                      component="div"
                      className="text-red-500 text-[0.8vw] absolute mt-[5.2vw] ml-[8vw]"
                    />
                  </div>

                  {/* Percentage Field */}
                  <div className="w-[22vw] relative flex flex-col">
                    <label className="text-[#1F4B7F] text-[1.1vw] font-semibold">
                      Percentage
                      <span className="text-[1vw] text-red-600 pl-[0.2vw]">
                        *
                      </span>
                    </label>

                    <div className="flex mt-[0.5vw] h-[3vw]">
                      <Field
                        type="text"
                        name="percentage"
                        id="percentage"
                        placeholder="Enter Offer Value"
                        autoComplete="off"
                        className="h-full w-full border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] border-r-0 text-[#1F487C] text-[1vw] outline-none px-[1vw] border-[#1F487C] rounded-l-[0.5vw] placeholder:text-[1vw] placeholder:font-sans"
                      />

                      <div
                        className={`w-[3vw] h-full flex items-center justify-center cursor-pointer border-t-[0.1vw] border-b-[0.25vw] border-r-[0.1vw] border-[#1F487C] text-[1vw] ${
                          values.value_symbol === "%"
                            ? "bg-[#1F487C] text-white font-semibold"
                            : "bg-white text-[#1F487C]"
                        } rounded-r-[0.5vw]`}
                        onClick={() => {
                          setFieldValue("value_symbol", "%");
                        }}
                      >
                        %
                      </div>
                    </div>

                    <ErrorMessage
                      name="percentage"
                      component="div"
                      className="text-red-500 text-[0.8vw] absolute bottom-[-1.2vw]"
                    />
                  </div>
                </div>

                <div className="flex justify-center mt-[3vw] mb-[1vw] gap-[2vw] ml-1">
                  <button
                    type="button"
                    onClick={() => {
                      setTogglePage(1);
                      setDealId("");
                      setActivePage(1);
                    }}
                    className=" h-[2.5vw] w-[10vw]  px-[0.75vw] py-[0.25vw] border-[#1F487C] border-[0.1vw]  text-[#1F487C] font-semibold rounded-md shadow-sm hover:shadow-none shadow-[#1F487C] text-[1vw]"
                    style={{ transition: "all 0.3s" }}
                  >
                    Back
                  </button>
                  <button
                    type="submit"
                    className=" h-[2.5vw] w-[10vw] px-[0.75vw] py-[0.25vw] border-[#1F487C] border-[0.1vw]  text-white bg-[#1F487C] font-semibold rounded-md shadow-sm hover:shadow-none shadow-[#1F487C] text-[1vw]"
                    style={{ transition: "all 0.3s" }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}

      <ModalPopup
        show={deletemodalIsOpen}
        onClose={closeDeleteModal}
        height="20vw"
        width="30vw"
        closeicon={false}
      >
        <DeleteList
          setDeleteModalIsOpen={setDeleteModalIsOpen}
          title={"Want to delete this TBS Deal"}
          api={`${apiUrl}/delete/tbsdeal/percentage/${deleteId}`}
          module={"tbsDeal"}
        />
      </ModalPopup>

      <ModalPopup
        show={isModalOpen}
        // onClose={closeModal}
        width="25vw"
        height="15vw"
        closeicon={false}
      ></ModalPopup>
      {togglepage === 1 ? (
        <div>
          {tbsDeal?.length > itemsper && (
            <div className="flex justify-end pt-[2.5vw]  pr-2">
              <ReactPaginate
                activePage={activePage}
                itemsCountPerPage={itemsper}
                totalItemsCount={tbsDeal?.length}
                pageRangeDisplayed={3}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link "
                activeClass="active"
                prevPageText={
                  <FontAwesomeIcon icon={faChevronLeft} size="1vw" />
                }
                nextPageText={
                  <FontAwesomeIcon icon={faChevronRight} size="1x" />
                }
                firstPageText={
                  <FontAwesomeIcon icon={faAngleDoubleLeft} size="1x" />
                }
                lastPageText={
                  <FontAwesomeIcon icon={faAngleDoubleRight} size="1x" />
                }
              />
            </div>
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
